@if (fields()) {
  <wl-simple-usp
    [theme]="theme()"
    [usp1]="usp1()!"
    [usp2]="usp2()!"
    [usp3]="usp3()!"
    [usp4]="usp4()!"
  />
}
